export const loadPageComponent = page =>
  import(
    /* webpackChunkName: "chunk-[request][index]" */
    /* webpackInclude: /\.js/ */
    /* webpackExclude: /__tests__|components|assets|utils|hooks|widgets|test-support|support|store|queries|default-content|typedefs|constants/ */
    `../pages/${page}`
  )
